<app-titolo-subtitolo
  [titolo]="'Policy di Sostenibilità'"
  [paddingTop]="10"
  [isArchiviato]="isArchiviato()"
></app-titolo-subtitolo>

<div mat-dialog-content class="dialog-center-cont" style="padding: 0px !important">
  <app-spinner-overlay></app-spinner-overlay>
  <mat-stepper
    [linear]="!isPubblicato() && !isArchiviato()"
    #stepper
    (selectionChange)="cambioStep($event)"
  >
    <mat-step [stepControl]="formPolicySostenibilita">
      <ng-scrollbar [visibility]="'hover'">
        <ng-template matStepLabel> Policy di sostenibilità </ng-template>

        <form
          [formGroup]="formPolicySostenibilita"
          [alignItems]="'flex-start'"
          appFormContainer
          [larghezza]="12"
          [gap]="10"
          [rowGap]="5"
          style="align-items: center"
        >
          <div appFormElement [larghezza]="12" [riempi]="true">
            <div class="titolo-sezione-dialog">Creazione Policy di Sostenibilità</div>

            <div class="descrizione-sezione-dialog">
              Seleziona l'anno e scegli tra l'approccio generico e quello settoriale. Se selezioni
              l'approccio settoriale il sistema elaborerà un framework basato sulle specificità del
              settore di appartenenza.<br />
              La scelta del sotto-settore aumenterà l'accuratezza dell'approccio selezionato.
            </div>
          </div>

          <div style="display: flex; flex-direction: column; flex: none; padding-right: 15px">
            <mat-label>Framework</mat-label>
            <mat-radio-group
              class="radio-tipo-sett"
              aria-label="Framework"
              formControlName="tipoSettore"
            >
              <div class="radio-container">
                <mat-radio-button
                  aria-label="Generico"
                  value="GENERALE"
                  [disabled]="
                    this.formPolicySostenibilita.get('id')?.value || !this.settoreGenerale
                  "
                >
                  Generale
                </mat-radio-button>
                <div class="eti-check">
                  <mat-icon matTooltip="Adatto ad aziende di ogni settore" class="info-icon">
                    info_outline
                  </mat-icon>
                </div>
              </div>

              <div class="radio-container">
                <mat-radio-button
                  aria-label="Specifico"
                  value="SPECIFICO"
                  [disabled]="
                    this.formPolicySostenibilita.get('id')?.value || !this.settoriAzienda.length
                  "
                >
                  Settoriale
                </mat-radio-button>
                @if (
                  !this.formPolicySostenibilita.get('id')?.value && !this.settoriAzienda.length
                ) {
                  <div class="eti-check">
                    <mat-icon matTooltip="Estensione settoriale non attiva" class="info-icon">
                      info_outline
                    </mat-icon>
                  </div>
                } @else {
                  <div class="eti-check">
                    <mat-icon
                      matTooltip="Sviluppato ad hoc per il settore di appartenenza dell'azienda"
                      class="info-icon"
                    >
                      info_outline
                    </mat-icon>
                  </div>
                }
              </div>
            </mat-radio-group>
          </div>

          <mat-form-field appFormElement [larghezza]="2">
            <mat-label>Anno</mat-label>
            <mat-select formControlName="anno" placeholder="Anno">
              <mat-option
                *ngFor="let anno of arrayAnni"
                [value]="anno"
                [disabled]="ctrAnnoPolicyUtilizzata(anno)"
                >{{ anno }}</mat-option
              >
            </mat-select>
          </mat-form-field>

          <mat-form-field
            appFormElement
            [larghezza]="2"
            class="input-form"
            [riempi]="true"
            *ngIf="this.formPolicySostenibilita.get('tipoSettore')?.value === 'SPECIFICO'"
          >
            <mat-label>Settore</mat-label>
            <mat-select formControlName="settori" placeholder="Settore" [compareWith]="compareById">
              <mat-option
                *ngFor="let set of settoriAzienda"
                [value]="set"
                [disabled]="ctrSettorePolicyUtilizzata(set)"
                >{{ set.titolo }}</mat-option
              >
            </mat-select>
          </mat-form-field>

          <mat-form-field
            appFormElement
            [larghezza]="5"
            class="input-form"
            *ngIf="
              this.formPolicySostenibilita.get('tipoSettore')?.value === 'SPECIFICO' &&
              arraySottoSettori?.length
            "
          >
            <mat-label>Sotto-settori</mat-label>
            <mat-select
              formControlName="sottoSettori"
              placeholder="Sotto-settori"
              [compareWith]="compareById"
              multiple
            >
              <mat-option *ngFor="let sottoSet of arraySottoSettori" [value]="sottoSet">{{
                sottoSet.titolo
              }}</mat-option>
            </mat-select>
          </mat-form-field>

          <div class="separatore" appFormElement [larghezza]="12">
            <app-separatore-label [styleSeparatore]="'small'"></app-separatore-label>
          </div>

          <div appFormElement [larghezza]="12" [riempi]="true">
            <div class="titolo-sezione-dialog">
              Non partire da zero, lega la tua Policy ad altre attività
            </div>

            <div class="descrizione-sezione-dialog">
              Collegando altri moduli alla policy di sostenibilità potrai utilizzare le informazioni
              inserite precedentemente. Selezionare l'Analisi di Materialità avrà un impatto sulla
              scelta delle tematiche di sostenibilità da sviluppare.
            </div>
          </div>

          <!-- INCLUSIONE MODULI ESTERNI -->
          <app-inclusione-moduli
            [annoModulo]="this.formPolicySostenibilita.get('anno')?.value"
            [idModulo]="this.formPolicySostenibilita.get('id')?.value"
            [settore]="this.formPolicySostenibilita.get('settori')?.value"
            [sottoSettore]="this.formPolicySostenibilita.get('sottoSettori')?.value"
            [tipoModulo]="'POLICY'"
            [idModuiliInclusi]="idModuliInclusi"
          ></app-inclusione-moduli>
        </form>
      </ng-scrollbar>
    </mat-step>

    <!-- SELEZIONE TEMATICHE   -->
    <mat-step>
      <ng-template matStepLabel> Tematiche </ng-template>

      <app-cfg-questionario
        #surveyComp
        [isPermessoSoloRead]="isPermessoSoloRead"
        [tipoQuestionario]="'POLICY'"
        [cfgQuestionario]="policy"
        [idSostenibilita]="formPolicySostenibilita.get('id')?.value"
        [nascondiTitolo]="true"
      ></app-cfg-questionario>
    </mat-step>

    <!--  ---------------------- I M P E G N I ---------- -->
    <mat-step>
      <ng-template matStepLabel> Impegni </ng-template>
      <div appFormContainer [larghezza]="2" style="align-items: center">
        <div appFormElement [larghezza]="1" [riempi]="true">
          <div class="titolo-sezione-dialog">Selezione degli Impegni</div>
          <div class="descrizione-sezione-dialog">
            Gli impegni rappresentano delle dichiarazioni di intento dell’azienda ad operare creando
            impatti positivi e limitando quelli negativi rispetto alle specifiche tematiche di
            sostenibilità.<br />
            Seleziona almeno un impegno aziendale e descrivilo attraverso la compilazione.
            Scegliendo dalla lista proposta troverai linee guida ad hoc per la compilazione.
          </div>
        </div>
      </div>

      <app-selezione-impegni-policy
        [isPermessoSoloRead]="isPermessoSoloRead"
        [objQuestionario]="objQuestionarioImpegni"
        chiaveElemento="elementi"
        [idContest]="this.formPolicySostenibilita.get('id')?.value"
        [stato]="policy?.stato"
        chiaveElementoSelezione="impegno"
        [settore]="policy?.settori"
      >
      </app-selezione-impegni-policy>
    </mat-step>

    <!--  ---------------------- Azioni e Buone Pratiche  ---------- -->
    <mat-step>
      <ng-template matStepLabel> Azioni e Buone Pratiche </ng-template>
      <div appFormContainer [larghezza]="2" style="align-items: center">
        <div appFormElement [larghezza]="1" [riempi]="true">
          <div class="titolo-sezione-dialog">Selezione delle Azioni e Buone Pratiche</div>
          <div class="descrizione-sezione-dialog">
            Seleziona le azioni e le buone pratiche che l’azienda mette in atto per le diverse
            tematiche di sostenibilità.<br />
            Attraverso il pulsante <mat-icon>edit</mat-icon> potrai modificare la descrizione delle
            singole azioni selezionate per rappresentare al meglio le iniziative messe in atto
            dall’azienda, oltre a inserire specifiche istruzioni di compilazione per la figura
            designata all’attività attraverso il campo “Note”.
          </div>
        </div>
      </div>

      <app-selezione-azioni-buonepratiche-policy
        [isPermessoSoloRead]="isPermessoSoloRead"
        [objQuestionario]="objQuestionarioAzioniBP"
        chiaveElemento="elementi"
        [idContest]="this.formPolicySostenibilita.get('id')?.value"
        [stato]="policy?.stato"
        chiaveElementoSelezione="azionebp"
        [settore]="policy?.settori"
      >
      </app-selezione-azioni-buonepratiche-policy>
    </mat-step>

    <!--  ---------------------- Certificazioni  ---------- -->
    <mat-step>
      <ng-template matStepLabel> Certificazioni </ng-template>
      <div appFormContainer [larghezza]="2" style="align-items: center">
        <div appFormElement [larghezza]="1" [riempi]="true">
          <div class="titolo-sezione-dialog">Selezione delle Certificazioni</div>
          <div class="descrizione-sezione-dialog">
            Seleziona le certificazioni possedute dall’azienda
          </div>
        </div>
      </div>

      <app-selezione-certificazioni-policy
        [isPermessoSoloRead]="isPermessoSoloRead"
        [objQuestionario]="objQuestionarioCertificazioni"
        chiaveElemento="elementi"
        [idContest]="this.formPolicySostenibilita.get('id')?.value"
        [stato]="policy?.stato"
        chiaveElementoSelezione="certif"
        [settore]="policy?.settori"
      >
      </app-selezione-certificazioni-policy>
    </mat-step>

    <!--  ---------------------- C O M I T A T I  ---------- -->
    <mat-step>
      <ng-template matStepLabel> Ruoli e responsabilità </ng-template>

      <div style="height: 10px"></div>
      <app-seleziona-comitati
        [isPermessoSoloRead]="isPermessoSoloRead"
        [idPolicy]="this.formPolicySostenibilita.get('id')?.value"
        [isPubblicato]="isPubblicato() || isArchiviato()"
      ></app-seleziona-comitati>
    </mat-step>
    <!--  ---------------------- C R U S C O T T O ---------- -->
    <mat-step>
      <ng-template matStepLabel> Cruscotto </ng-template>
      <div class="barra-titolo-cruscotto">
        <div style="display: flex; flex-direction: column; flex: 1">
          <div class="titolo-sezione-dialog">Cruscotto Policy di Sostenibilità</div>

          <div class="descrizione-sezione-dialog">
            Visualizza e gestisci ogni aspetto relativo alla compilazione: avanzamento,
            configurazione dei testi mail, invio e notifiche.
          </div>
        </div>

        <!-- TOTALI CRUSCOTTO -->
        @if (this.formPolicySostenibilita.get('id')?.value) {
          <app-totali-cruscotto
            #totaliCruscotto
            [idModulo]="this.formPolicySostenibilita.get('id')?.value"
            [tipoModulo]="'POLICY'"
          >
          </app-totali-cruscotto>
        }
      </div>
      <ng-scrollbar>
        <div style="padding-right: 15px">
          <app-lista-tabellare
            #tabella
            [defaultPageSize]="4"
            [fnCaricamentoDati]="fnCaricamentoDatiCruscotto"
            [colonne]="colonne"
            [maxNrButton]="1"
            [filtri]="filtri"
            (bottoniListaClick)="bottoniListaClick($event)"
            *ngIf="this.formPolicySostenibilita.get('id')?.value"
          >
            <ng-container btnEnd>
              <button
                [disabled]="!isPermessoInvioMail"
                mat-flat-button
                class="primary-button"
                color="primary"
                (click)="template()"
              >
                <mat-icon matSuffix>settings</mat-icon>
                Config. Testi
              </button>

              <button
                [disabled]="!isPermessoInvioMail || isPermessoSoloRead"
                mat-flat-button
                class="primary-button"
                color="primary"
                (click)="inviaTutti()"
              >
                <mat-icon matSuffix>mail</mat-icon>
                Invia a Tutti
              </button>

              <button
                [disabled]="!isPermessoInvioMail || isPermessoSoloRead"
                mat-flat-button
                class="primary-button"
                color="primary"
                (click)="notificaTutti()"
              >
                <mat-icon matSuffix>notifications_active</mat-icon>
                Notifica Tutti
              </button>
            </ng-container>
          </app-lista-tabellare>
        </div>
      </ng-scrollbar>
    </mat-step>
    <!--  ---------------------- Perimetro e destinatari  ---------- -->
    <mat-step>
      <ng-template matStepLabel> Documento </ng-template>

      <div style="height: 10px"></div>
      <app-seleziona-perimetro-destinatari
        [isPermessoSoloRead]="isPermessoSoloRead"
        [idPolicy]="this.formPolicySostenibilita.get('id')?.value"
      ></app-seleziona-perimetro-destinatari>
    </mat-step>

    <!--  ---------------------- S T A M P A ---------- -->
    <mat-step>
      <ng-template matStepLabel> Configurazione Stampa </ng-template>

      <app-cfg-stampa
        [isPermessoSoloRead]="isPermessoSoloRead"
        [fnGetConfigStampa]="fnGetConfigStampa"
        [fnSalvaCfgStampa]="fnSalvaCfgStampa"
        [fnCaricaImg]="fnImportaImmagine"
        [fnEliminaImg]="fnEliminaImg"
        (loading)="toggleLoading($any($event))"
      ></app-cfg-stampa>
    </mat-step>
  </mat-stepper>
</div>

<div mat-dialog-actions class="dialog-footer-cont">
  <div>
    <button
      mat-flat-button
      color="accent"
      [disabled]="stepper.selectedIndex === 0"
      (click)="indietro()"
      class="accent-button"
    >
      Indietro
    </button>
  </div>

  <div *ngIf="stepper.selectedIndex < 8">
    <button
      mat-flat-button
      color="primary"
      (click)="avantiHTML()"
      class="primary-button"
      #btnAvanti
    >
      Avanti
    </button>
  </div>

  <ng-container *ngIf="stepper.selectedIndex === 5">
    <button
      mat-flat-button
      color="accent"
      (click)="creaComitato()"
      [disabled]="isPermessoSoloRead"
      class="accent-button"
    >
      Nuovo comitato
    </button>
  </ng-container>

  <div *ngIf="mostraBottoneAssegnazioni">
    <button
      mat-flat-button
      color="primary"
      (click)="assegnazioni(stepper.selectedIndex)"
      class="primary-button"
    >
      <mat-icon>person_edit</mat-icon> Assegnazioni
    </button>
  </div>

  <ng-container *ngIf="stepper.selectedIndex === 8">
    <button
      *ngIf="!isPermessoSoloRead"
      mat-flat-button
      color="primary"
      (click)="salvaCfgStampa()"
      class="primary-button"
    >
      Salva
    </button>
    <button
      matDialogClose
      *ngIf="isPermessoSoloRead"
      mat-flat-button
      color="accent"
      class="primary-button"
    >
      Chiudi
    </button>
    <button
      [disabled]="!this.cfgStampaComponent.isPermessoStampa"
      mat-flat-button
      color="accent"
      (click)="stampa()"
      class="accent-button"
      style="margin: 0 !important"
    >
      <mat-icon class="material-icons-outlined"> print </mat-icon>Stampa
    </button>
  </ng-container>
</div>
